import React from 'react';
import PropTypes from 'prop-types';
import TextInput from "./TextInput.js";
/** 
 * React class that renders an Input that only accepts numbers 
 * @see {@link TextInput} Class derived from
 * @property {function} onChange - function to be called with the widgets onChange 
 * @property {boolean} changeOnBlur 
 * @property {boolean} changeOnReturn 
 * @property {string} hint - hint text for the widget 
 * @property {number} min - minimum value that the input can be 
 * @property {number} max - maximum value that the input can be 
 * @property {number} maxLength 
 * @property {number} size 
 * @property {boolean} focus
 * @property {boolean} float - determines if the value can be a float or not 
 * */
import { jsx as _jsx } from "react/jsx-runtime";
class NumericInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    changeOnBlur: PropTypes.bool,
    changeOnReturn: PropTypes.bool,
    hint: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    maxLength: PropTypes.number,
    size: PropTypes.number,
    focus: PropTypes.bool,
    float: PropTypes.bool
  };

  /**
   * (Internal) onChange of the element, calls the onChange prop
   */
  onChange = ({
    value,
    error,
    data
  }) => {
    try {
      const {
        onChange
      } = this.props;
      let v = value == null ? null : parseFloat(value);
      if (Number.isNaN(v)) {
        v = null;
      }
      if (onChange) {
        onChange({
          value: v,
          error,
          data
        });
      }
    } catch (ex) {
      console.log('error parsing', value, error, ex);
    }
  };

  /** (Internal) - determines which key presses to accept this method filters out all non-numbers */
  acceptKey = evt => {
    const {
      min,
      float
    } = this.props;
    const start = evt.target.selectionStart;
    const stop = evt.target.selectionEnd;
    const val = evt.target.value;
    const inp = String.fromCharCode(evt.charCode);
    if (inp === '-' && min == null || min != null && min < 0) {
      // allow negative at beginning

      // Condition being met when we try to type a digit after having typed the minus sign.
      // if ( start !== 0 ) {
      //   return false;
      // }

      const negIndex = val.indexOf('-');
      if (negIndex === 0 && stop === 0) {
        return false;
      }
      return true;
    }
    const c = evt.charCode;
    if (float) {
      const dotIndex = val.indexOf('.');
      if (inp === '.' && dotIndex >= 0) {
        if (stop - start === 1 && dotIndex === start) {
          return true; // replace dot with dot.
        }
        if (!(start <= dotIndex && dotIndex < stop)) {
          return false; // cant have 2 dots
        }
      }
      if (/[0-9.]/.test(inp)) {
        return true;
      }
    } else if (/[0-9]/.test(inp)) {
      return true;
    }
    return false;
  };

  /** (Internal) validation function that well not let invalid values be submitted */
  validator = val => {
    const {
      min,
      max
    } = this.props;
    if (val == null || val === '') {
      return true;
    }
    const v = parseFloat(val);
    if (isNaN(v)) {
      // eslint-disable-line no-restricted-globals
      return false;
    }
    if (min != null && v < min) {
      return false;
    }
    if (max != null && v > max) {
      return false;
    }
    return true;
  };
  getValueString = () => {
    const {
      value
    } = this.props;
    if (value == null) {
      return '';
    }

    // Necessary, given that a template string will stringify -0 as '0'.
    if (1 / value === -Infinity) {
      return '-0';
    }
    return `${value}`;
  };
  render() {
    const {
      float,
      ...rest
    } = this.props;
    const value = this.getValueString();
    return /*#__PURE__*/_jsx(TextInput, {
      ...rest,
      validator: this.validator,
      acceptKey: this.acceptKey,
      onChange: this.onChange,
      value: value
    });
  }
}
export default NumericInput;